import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AddPhotoImageData } from "common/types";
import User from "../../../types/user";
import { flagVenueAccessibiilityDesktop } from "../../../apis";

export function useFlagAccessibility() {
  const queryClient = useQueryClient();
  const { mutate, error, status, data } = useMutation({
    mutationFn: ({
      categoryId,
      businessId,
      typeQuestionId,
      typeQuestionTagId,
      accessToken,
      notes,
      images,
    }: {
      businessId: string;
      categoryId: string;
      typeQuestionId: string;
      typeQuestionTagId: string;
      accessToken: string;
      notes: string;
      images: AddPhotoImageData[];
    }) => {
      return flagVenueAccessibiilityDesktop(
        businessId,
        categoryId,
        typeQuestionId,
        typeQuestionTagId,
        accessToken,
        notes,
        images
      );
    },
    onSuccess: () => {},
  });
  return { mutate, error, isPending: status === "pending", data };
}
